@if (entity(); as entity) {
  @if (summary(); as summary) {
    <div class="container">
      <div class="container__id-block">
        <h3>{{ entity[summary.titleField] }}</h3>
        <p>{{ entity[summary.addressField] }}</p>
      </div>
      @if (mapImgUrl(); as mapImgUrl) {
        <div class="container__map-block">
          <img [src]="mapImgUrl" />
        </div>
      }
      <div class="container__fields-block-container">
        @for (field of summary.fields; let index = $index; track field) {
          <ng-container *ngTemplateOutlet="fieldConfig; context: { $implicit: field, entity, index }"></ng-container>
        }
      </div>
      @if (editMode()) {
        <div class="container__fields-block-container__item">
          <ts-button
            type="stroked"
            class="ml-2"
            color="basic"
            type="icon"
            icon="add_circle"
            matTooltip="Add Field"
            (click)="addField()"
          />
        </div>
      }
    </div>
  }
}
<ng-template #fieldConfig let-field let-entity="entity" let-index="index">
  @if (field | fieldDef: relatedTo(); as fieldDef) {
    <div class="container__fields-block-container__item">
      @if (editMode()) {
        <mat-form-field>
          <mat-select [value]="field" (selectionChange)="fieldChanged($event, index)">
            @for (item of fields$ | async; track item) {
              <mat-option [value]="item.name">{{ item.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <ts-button
          type="stroked"
          color="accent"
          class="ml-2"
          type="icon"
          icon="ts_trash-alt"
          matTooltip="Remove"
          color="basic"
          (click)="removeField(index)"
        />
      } @else {
        <h4
          TsFieldStyling
          [fieldBackgroundColor]="fieldStylingMap()?.[field]?.color"
          [fieldBold]="fieldStylingMap()?.[field]?.is_bold"
        >
          {{ entity[field] | readableField: entity : fieldDef : options() }}
        </h4>
        <p>{{ fieldDef.label }}</p>
      }
    </div>
  }
</ng-template>
